import { render, staticRenderFns } from "./MyColorNote.vue?vue&type=template&id=3b74773a&"
import script from "./MyColorNote.vue?vue&type=script&lang=ts&"
export * from "./MyColorNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports